import { createRouter, createWebHashHistory } from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/store'
NProgress.configure({
    easing: 'ease', // 动画方式
    speed: 500, // 递增进度条的速度
    showSpinner: false, // 是否显示加载ico
    trickleSpeed: 200, // 自动递增间隔
    minimum: 0.3,// 初始化时的最小百分比,
})
const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            name: '',
            redirect: '/step1',
            component: () => import('@/views/index/index.vue'),
            meta: {
                index: 1
            },
            children: [
                {
                    path: '/step1',
                    name: 'step1',
                    component: () => import('@/views/index/step1.vue')

                },
                {
                    path: '/step1-submit',
                    name: 'step1Submit',
                    component: () => import('@/views/index/step1-submit.vue')
                },
                {
                    path: '/step2',
                    name: 'step2',
                    component: () => import('@/views/index/step2.vue')
                },
                {
                    path: '/step3',
                    name: 'step3',
                    component: () => import('@/views/index/step3.vue')
                },
                {
                    path: '/step3-submit',
                    name: 'step3Submit',
                    component: () => import('@/views/index/step3-submit.vue')
                },
                {
                    path: '/step4',
                    name: 'step4',
                    component: () => import('@/views/index/step4.vue')
                },
                {
                    path: '/step4-submit',
                    name: 'step4submit',
                    component: () => import('@/views/index/step4-submit.vue')
                },
                {
                    path: '/step5',
                    name: 'step5',
                    component: () => import('@/views/index/step5.vue')
                },
                {
                    path: '/step5-submit',
                    name: 'step5-submit',
                    component: () => import('@/views/index/step5-submit.vue'),
                    // @deprecated 此页已被 step6.vue 取代，当前流程绕过
                    // 仅保留路由兼容历史入站链接，不做 UI 改造
                    meta: { deprecated: true }
                },
                {
                    path: '/step6',
                    name: 'step6',
                    component: () => import('@/views/index/step6.vue')
                },
                {
                    path: '/step7',
                    name: 'step7',
                    component: () => import('@/views/index/step7.vue')
                },
                {
                    path: '/step8',
                    name: 'step8',
                    component: () => import('@/views/index/step8.vue')
                },
                {
                    path: '/step9',
                    name: 'step9',
                    component: () => import('@/views/index/step9.vue')
                },
                {
                    path: '/step-waiting',
                    name: 'stepWaiting',
                    component: () => import('@/views/index/step-waiting.vue')
                },
                {
                    // 步骤总览（对应原型 home.html，Bento 九宫格 + 组委会联络）
                    path: '/home',
                    name: 'home',
                    component: () => import('@/views/index/home.vue')
                }
            ]
        },
        // 鉴权流程（独立站点：登录 / 注册企业 / 选择展会）
        {
            path: '/auth',
            component: () => import('@/views/auth/AuthLayout.vue'),
            children: [
                { path: 'login', name: 'login', component: () => import('@/views/auth/Login.vue') },
                { path: 'register', name: 'register', component: () => import('@/views/auth/Register.vue') },
                { path: 'meetings', name: 'meetings', component: () => import('@/views/auth/Meetings.vue') }
            ]
        }
    ]
})

router.beforeEach(async (to, from, next) => {
    //这这里开启加载条
    NProgress.start()

    // ============================================================
    // 登录守卫（独立站点）
    // ============================================================
    const token = store.state.token
    const publicPaths = ['/auth/login', '/auth/register']
    if (publicPaths.includes(to.path)) { next(); return }
    if (!token) {
        next({ path: '/auth/login', query: { redirect: to.fullPath } })
        return
    }
    const meetingId = store.state.meetingId
    if (!meetingId
        && !to.path.startsWith('/auth/meetings')
        && !to.path.startsWith('/auth/login')
        && !to.path.startsWith('/auth/register')) {
        next('/auth/meetings')
        return
    }

    // ============================================================
    // 展商层级拦截（子展商 → 等待页）
    // 修复：hash 模式下 window.location.search 取不到参数，改用 to.query
    // ============================================================
    const restrictedSteps = ['/step1', '/step1-submit', '/step2', '/step3', '/step3-submit']

    if (restrictedSteps.includes(to.path)) {
        try {
            const meetingIdQ = to.query.meetingId
            const corporateIdQ = to.query.corporateId

            if (meetingIdQ && corporateIdQ) {
                // 检查展商层级
                const response = await fetch(`/api2/application/exhibitorMessage?meetingId=${meetingIdQ}&corporateId=${corporateIdQ}`)
                const data = await response.json()

                if (data.code === 1 && data.data) {
                    const exhibitorData = data.data

                    // 如果是子展商（exhibitorLevel > 1），重定向到等待页面
                    if (exhibitorData.exhibitorLevel && exhibitorData.exhibitorLevel > 1) {
                        next({
                            path: '/step-waiting',
                            query: to.query
                        })
                        return
                    }
                }
            }
        } catch (error) {
            console.error('检查展商层级失败:', error)
        }
    }

    next()
})
router.afterEach(() => {
    // 在即将进入新的页面组件前，关闭掉进度条
    NProgress.done()
})
export default router
